/**
 * Svelte Init
 * =====================
 * Create svelte app
 *
 * @contributors: Mitch Downey [@mitchdowney] <contact@podverse.fm> (https://github.com/mitchdowney)
 *
 * @license: MIT License
 *
 */
import app from "@app/html/webcomponent.svelte";

export default app;
